import { IResponseProps } from '@/entities/Response'
import { ITalkProps } from '@/entities/Talk'

export const Types = {
  store: 'store',
  searched: 'searched',
  current: 'current',
  filter: 'filter',
  saving: 'saving',
  selected: 'selected'
}

export const path = 'talk/'

export class Store implements FluxStandardAction<IResponseProps<ITalkProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<ITalkProps>) {}
}

export class Searched implements FluxStandardAction<IResponseProps<ITalkProps>> {
  type = path + Types.searched
  constructor(public payload: IResponseProps<ITalkProps>) {}
}

export class Current implements FluxStandardAction<ITalkProps | null> {
  type = path + Types.current
  constructor(public payload: ITalkProps | null) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}

export class Saving implements FluxStandardAction<boolean | null> {
  type = path + Types.saving
  constructor(public payload: boolean | null) {}
}

export class Selected implements FluxStandardAction<ITalkProps | null> {
  type = path + Types.selected
  constructor(public payload: ITalkProps | null) {}
}
